import { Component, Inject, OnInit } from '@angular/core';
import { showError } from 'src/app/services/notify';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { CheckoutService } from 'src/app/services/checkout.service';
import { ShoppingService } from 'src/app/services/shopping.service';
import { timeout } from 'rxjs/operators';

@Component({
  selector: 'app-select-type-pay-modal',
  templateUrl: './select-type-pay-modal.component.html',
  styleUrls: ['./select-type-pay-modal.component.scss'],
})
export class SelectTypePayModalComponent implements OnInit {
  viewCart: any = [];

  selectPay = true;

  goPayBoolean = false;
  loading = false;
  paymentError = '';

  totalCart!: number;

  user: any = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<SelectTypePayModalComponent>,
    public checkoutService: CheckoutService,
    public shopping: ShoppingService,
    private authService: AuthService,

    public router: Router
  ) {}

  async ngOnInit() {
    this.viewCart = this.shopping.getShoppingCart();

    this.calculateTotalCart();

    await this.authService.getUserFirebase().subscribe((x) => {
      this.user = x;

    });
  }
  closeDialog(action: any) {
    this.dialogRef.close(action);
  }

  async goPay() {
    if (this.goPayBoolean || !this.viewCart.length) return;
    this.goPayBoolean = true;
    this.loading = true;
    this.paymentError = '';
    const access = this.router.url.includes('/events');
    try {
      const request = access
        ? await this.checkoutService.checkoutAccess(this.viewCart)
        : await this.checkoutService.checkoutBar(this.viewCart);
      request.pipe(timeout(20000)).subscribe({
        next: (data: any) => {
          if (data?.result?.init_point) {
            window.location.href = data.result.init_point;
            return;
          }
          this.paymentError = this.checkoutService.checkoutErrorMessage(data, access ? 'evento' : 'carta');
          if (data?.code === 404 && Array.isArray(data.error)) {
            this.paymentError = 'La disponibilidad cambió. Vuelve a tus entradas y revisa la cantidad seleccionada.';
          }
          this.goPayBoolean = false;
          this.loading = false;
        },
        error: () => this.paymentFailed()
      });
    } catch { this.paymentFailed(); }
  }

  private paymentFailed(): void {
    this.paymentError = 'No pudimos iniciar el pago. Revisa tu conexión y vuelve a intentarlo.';
    this.goPayBoolean = false;
    this.loading = false;
  }

  calculateTotalCart() {
    this.totalCart = this.viewCart.reduce(
      (acc: any, item: any) => acc + item.quantity * item.price,
      0
    );
  }
}
